'use client';

import { useFormState } from 'react-hook-form';

import type { FormFields } from './formTypes';
import { purchaseFormCtx } from './purchaseFormCtx';

/**
 * Access form state (errors, validity, submission status)
 *
 * @returns Form state with reactive subscriptions
 *
 * @example
 * const { isSubmitSuccessful, isValid, errors } = usePurchaseFormState();
 */
export function usePurchaseFormState() {
    return useFormState<FormFields>({ control: purchaseFormCtx.control });
}
